import { render, staticRenderFns } from "./GlobalSummary.vue?vue&type=template&id=1fd44738"
import script from "./GlobalSummary.vue?vue&type=script&lang=js"
export * from "./GlobalSummary.vue?vue&type=script&lang=js"
import style0 from "./GlobalSummary.vue?vue&type=style&index=0&id=1fd44738&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports